import "./NearbyProviders.css";
import ProviderCard from "./ProviderCard";

function NearbyProviders({ providers = [] }) {

  // =====================================================
  // NORMALIZE
  // =====================================================

  const normalizeProviderType = (value = "") => {
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/[-_]/g, " ")
      .replace(/\s+/g, " ");
  };

  // =====================================================
  // DEBUG
  // =====================================================

  console.log("🔥 NEARBY PROVIDERS:", providers);

  console.table(
    providers.map((provider) => ({
      id: provider._id || provider.id || provider.providerId,

      name:
        provider.businessName ||
        provider.business?.businessName ||
        provider.name,

      providerType: provider.providerType,

      normalizedType: normalizeProviderType(
        provider.providerType
      ),
    }))
  );

  // =====================================================
  // CATEGORIES
  // =====================================================

  const categories = [
    {
      key: "home-chef",
      title: "Home Chefs",
      icon: "🏠",
      types: [
        "home chef",
        "home kitchen",
      ],
    },

    {
      key: "restaurant",
      title: "Restaurants",
      icon: "🍽️",
      types: [
        "restaurant",
      ],
    },

    {
      key: "hotel",
      title: "Hotels",
      icon: "🏨",
      types: [
        "hotel",
      ],
    },

    {
      key: "bakery",
      title: "Bakeries",
      icon: "🧁",
      types: [
        "bakery",
      ],
    },

    {
      key: "catering",
      title: "Catering",
      icon: "🍱",
      types: [
        "catering",
      ],
    },

    {
      key: "provision-store",
      title: "Provision Stores",
      icon: "🛒",
      types: [
        "provision store",
      ],
    },
  ];

  // =====================================================
  // GET PROVIDERS BY CATEGORY
  // =====================================================

  const getProvidersByCategory = (category) => {

    return providers.filter((provider) => {

      const providerType = normalizeProviderType(
        provider.providerType ||
        provider.businessType ||
        provider.providerCategory ||
        provider.type ||
        ""
      );

      return category.types.includes(
        providerType
      );
    });
  };

  // =====================================================
  // DEBUG CATEGORY COUNTS
  // =====================================================

  categories.forEach((category) => {

    const matched =
      getProvidersByCategory(category);

    console.log(
      `📦 ${category.title}:`,
      matched.length,
      matched
    );
  });

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <section className="provider-section">

      {/* =================================================
          HEADER
      ================================================= */}

      <div className="provider-header">

        <h2>
          Nearby Businesses
        </h2>

      </div>

      {/* =================================================
          NO PROVIDERS
      ================================================= */}

      {providers.length === 0 ? (

        <div className="no-provider">
          No nearby businesses found.
        </div>

      ) : (

        <div className="provider-category-container">

          {categories.map((category) => {

            const categoryProviders =
              getProvidersByCategory(category);

            // Hide empty categories
            if (categoryProviders.length === 0) {
              return null;
            }

            return (

              <div
                className="provider-category"
                key={category.key}
              >

                {/* CATEGORY HEADER */}

                <div className="provider-category-header">

                  <h3>

                    <span className="category-icon">
                      {category.icon}
                    </span>

                    {category.title}

                  </h3>

                </div>

                {/* PROVIDER GRID */}

                <div className="provider-grid">

                  {categoryProviders.map(
                    (provider) => {

                      const providerId =
                        provider.providerId ||
                        provider._id ||
                        provider.id;

                      return (
                        <ProviderCard
                          key={providerId}
                          provider={{
                            ...provider,
                            providerId,
                          }}
                        />
                      );

                    }
                  )}

                </div>

              </div>

            );

          })}

        </div>

      )}

    </section>
  );
}

export default NearbyProviders;